import { Component } from '@angular/core';

@Component({
  templateUrl: './sl-home.component.html',
})
export class SLHomeComponent {
  
}